<template>
    <div>
        <slot />
    </div>
</template>
<script type="text/babel">
import HasSubscriptions from '@makeabledk/vue-ui/mixins/has-subscriptions'

export default {
    mixins: [HasSubscriptions],

    props: ['root'],

    mounted() {
        this.subscribe(this.setAriaHidden())
    },

    methods: {
        /**
         * Original implementation found in
         * @author Ryan Florence
         * @link https://github.com/reach/reach-ui/blob/master/packages/dialog/src/index.js#L9-L38
         */
        setAriaHidden() {
            const root = document.querySelector(this.root) //FocusProvider.getRoot()
            const element = this.getParentUntilRoot(root)

            let originalValues = []
            let rootNodes = []

            // Array.prototype.forEach.call(document.querySelectorAll("body > *"), node => {
            Array.prototype.forEach.call(root.children, (node) => {
                if (node === element) {
                    return
                }
                let attr = node.getAttribute('aria-hidden')
                let alreadyHidden = attr !== null && attr !== 'false'
                if (alreadyHidden) {
                    return
                }
                originalValues.push(attr)
                rootNodes.push(node)
                node.setAttribute('aria-hidden', 'true')
            })

            return {
                unsubscribe: () =>
                    rootNodes.forEach((node, index) => {
                        let originalValue = originalValues[index]
                        if (originalValue === null) {
                            node.removeAttribute('aria-hidden')
                        } else {
                            node.setAttribute('aria-hidden', originalValue)
                        }
                    }),
            }
        },

        getParentUntilRoot(root) {
            let el = this.$el

            while (el.parentElement !== root && el.parentElement !== document.body) {
                el = el.parentElement
            }

            return el
        },
    },
}
</script>
